export interface ISubmitAttendeesListData {
    selectedAttendee?: string;
    role?: string;
    email?: number;
    isRequired?: boolean;
}

export class AttendeesList {
    selectedAttendee: string;
    role: string;
    email: number;
    isRequired: boolean;
    constructor(data: Partial<ISubmitAttendeesListData>) {
        this.selectedAttendee = data?.selectedAttendee;
        this.role = data?.role;
        this.email = data?.email;
        this.isRequired = data?.isRequired;
    }
}